<template>
  <yd-dialog
    :title="'获取我的行程单'"
    :visible="showItinerary"
    append-to-body
    width="30%"
    @close="closeDialog"
  >
    <el-form :model="ruleForm" :rules="rules" ref="formName" label-width="0" class="demo-ruleForm">
      <div class="font-14 color-333" style="font-weight: 700">{{ itineraryInfo.time || '' }}</div>
      <div class="font-12 color-666 margin-top-10"
        >{{ isPick ? itineraryInfo.ferryStartAddress : itineraryInfo.departureStationAddress }} ——
        {{ isSend ? itineraryInfo.ferryEndAddress : itineraryInfo.destinationStationAddress }}</div
      >
      <el-divider />
      <el-checkbox-group v-model="itineraryValue">
        <div
          v-for="(item, index) in itineraryInfo.ticketAndFerryFOrderVos"
          :key="index"
          class="margin-bottom-7"
        >
          <el-checkbox :label="item.id">
            <div class="flex flex-align-center flex-justify-between" style="width: 100%">
              <div class="color-000">{{ item.label }}</div>
              <div class="color-redFont">￥{{ item.amount }}</div>
            </div>
          </el-checkbox>
        </div>
      </el-checkbox-group>
      <div class="flex flex-align-center flex-justify-end">
        合计金额：<div class="color-redFont">￥{{ priceTotal.toFixed(2) || 0.0 }}</div>
      </div>
      <el-form-item prop="email" class="margin-top-15">
        <el-input
          style="width: 100%; background: #f6f6f6; border-radius: 10px"
          v-model.trim="ruleForm.email"
          placeholder="在此输入您的电子邮箱（必填）"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <!-- <el-button @click="closeDialog" size="mini">取 消</el-button> -->
      <el-button type="primary" style="width: 100%" @click="handleConfirm" :loading="saveLoading">
        获取
      </el-button>
    </template>
  </yd-dialog>
</template>

<script >
import { Message } from 'element-ui';
import { ref, reactive, computed } from '@vue/composition-api';
import { isEmail } from '@/util/validate';
import { sendItinerary, getOrderItineraryMsg } from '@/api/intercityorder';
const __sfc_main = {};
__sfc_main.props = {
  showItinerary: {
    type: Boolean,
    default: false
  },
  orderNo: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const rules = {
    email: [{
      required: true,
      message: '请输入您的电子邮箱',
      trigger: 'blur'
    }, {
      validator: function (rule, value, callback) {
        if (!isEmail(value)) {
          callback(new Error('邮箱地址错误，请检查'));
        } else {
          callback();
        }
      },
      trigger: 'blur'
    }]
  };
  const ruleForm = reactive({
    email: ''
  });
  const saveLoading = ref(false);
  const closeDialog = () => {
    formName.value.resetFields();
    pickId.value = null;
    sendId.value = null;
    itineraryValue.value = [];
    itineraryInfo.value = {};
    emit('colseItinerary');
  };
  const formName = ref(null);
  const handleConfirm = () => {
    const {
      ticketAndFerryFOrderVos
    } = itineraryInfo.value;
    // 获取选中的座位信息
    const ferryInfo = [];
    ticketAndFerryFOrderVos.forEach(item => {
      if (itineraryValue.value.includes(item.id)) {
        ferryInfo.push({
          id: item.id,
          type: item.type
        });
      }
    });
    // 判断是否有选择请选择乘车人
    const index = ferryInfo.findIndex(item => item.type === 1);
    if (index === -1) {
      Message.error('请选择乘车人');
      return;
    }
    formName.value.validate(async valid => {
      if (valid) {
        const params = {
          // orderId: props.orderNo * 1,
          email: ruleForm.email,
          list: ferryInfo
        };
        console.log('params', params);
        saveLoading.value = true;
        const {
          code
        } = await sendItinerary(params);
        saveLoading.value = false;
        if (code) return;
        formName.value.resetFields();
        Message.success('获取成功，请关注您的邮箱～');
        closeDialog();
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  };
  const pickId = ref(null);
  const sendId = ref(null);
  const itineraryInfo = ref({});
  const itineraryValue = ref([]);
  const init = async orderId => {
    const {
      code,
      data
    } = await getOrderItineraryMsg({
      orderId
    });
    if (code) return;
    data.time = data.departureDate + ' ' + data.departureTime.substr(0, 5);
    data.ticketAndFerryFOrderVos.forEach(item => {
      item.label = item.type === 1 ? item.passengerName + ' ' + item.seat : item.forderType === 1 ? '接服务' : '送服务';
      item.amount = item.amount.toFixed(2);
      itineraryValue.value.push(item.id);
      if (item.forderType === 1) {
        // 设置接id
        pickId.value = item.id;
      }
      if (item.forderType === 2) {
        // 设置送id
        sendId.value = item.id;
      }
    });
    itineraryInfo.value = data;
  };
  const priceTotal = computed(() => {
    return itineraryValue.value.length && itineraryValue.value.reduce((pre, cur) => {
      if (!itineraryInfo.value.ticketAndFerryFOrderVos) return 0.0;
      const obj = itineraryInfo.value.ticketAndFerryFOrderVos.find(item => item.id === cur);
      pre = pre + obj.amount * 1;
      return pre;
    }, 0);
  });
  const isPick = computed(() => {
    return itineraryValue.value.includes(pickId.value);
  });
  const isSend = computed(() => {
    return itineraryValue.value.includes(sendId.value);
  });
  return Object.assign({
    rules,
    ruleForm,
    saveLoading,
    closeDialog,
    formName,
    handleConfirm,
    itineraryInfo,
    itineraryValue,
    priceTotal,
    isPick,
    isSend
  }, {
    init
  });
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .el-checkbox {
    width: 100%;
    display: flex;
    align-items: flex-end;
    color: #333;
    ::v-deep .el-checkbox__label {
      width: 100% !important;
      display: flex;
      flex: 1;
    }
  }
  ::v-deep input {
    background: #f6f6f6;
    border-radius: 10px;
    border: none;
  }

  ::v-deep {
    .el-dialog__body {
      padding: 5px 20px 20px;
    }
    .el-dialog__title {
      font-weight: bold;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #22c655;
      border-color: #22c655;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #333;
    }
  }
  ::v-deep .footer {
    border-top: none !important;
  }
</style>
